"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driversLicense = void 0;
const enums_1 = require("@bemlo/enums");
exports.driversLicense = {
    [enums_1.DriversLicense.MANUAL]: 'License for a manual car',
    [enums_1.DriversLicense.AUTOMATIC]: 'License for an automatic car',
    [enums_1.DriversLicense.NONE]: "No driver's licence",
};
